var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.58 13.06",
    "aria-labelledby": "brandIcon brandDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M21.36 6.61h-3.95V5.53a1.68 1.68 0 00-1.72-1.7H14.1V2.17c0-.51.09-.56.81-.56a.82.82 0 00.81-.8A.81.81 0 0015 0h-1.7a.81.81 0 00-.81.81v3h-1.66a1.65 1.65 0 00-1.7 1.7v1.1H5.24A3.23 3.23 0 002.13 9h-.52v-.77a.81.81 0 00-1.61 0v3.23a.81.81 0 001.61 0v-.81h.53a3.22 3.22 0 003.1 2.41h16.12a3.23 3.23 0 000-6.45z"
  })));
}

export default SvgBrand;